import * as React from "react";
import {
    DisplayFeatureType, CommonAssociationFeature, DisplayFeature
} from "../../../contract-features-3/domain";
import {Button} from 'react-bootstrap';
import FeatureList from "./FeatureList";
import {AssociatedFeature} from "../../domain/AssociatedFeature";
import {AssociationJson} from "../../domain/AssociationJson";
import {
    SelectTargetFeatureType,
    SetNvdbSearchDistance,
    ToggleSelectedAssociationTarget
} from "../../../../actions/actions";
import {FeatureTypeSummary} from "../../../../../integration/representation/feature-type";
import {FeatureTypeAttributes} from "../../state/AssociationsState";


interface NvdbChildAssociationTabProps {
    selectedAssociation: AssociatedFeature;
    selectedAssociationTargetType: FeatureTypeAttributes;
    selectedTargetFeatures: CommonAssociationFeature[];
    selectedSourceFeature: DisplayFeature;

    featureTypes: FeatureTypeSummary[];
    associationTargetTypes: DisplayFeatureType[];
    targetFeatures: CommonAssociationFeature[];
    associationsFlat: AssociationJson[];

    onSelectTargetFeatureType: SelectTargetFeatureType;
    onSelectTargetFeature: ToggleSelectedAssociationTarget;
    onAssociateTargets: Function;
    onFetchNvbdObjects: Function;

    nvdbSearchDistance: number;
    setNvdbSearchDistance: SetNvdbSearchDistance;
}

interface NvdbChildAssociationTabState {
    distance: number;
}

export default class NvdbChildAssociationsTab extends React.Component<NvdbChildAssociationTabProps, NvdbChildAssociationTabState> {

    constructor(props: NvdbChildAssociationTabProps) {
        super(props);
        this.state = {
            distance: 1
        }
    }

    handleSelect(value: string) {
        const parsedValue = parseInt(value);
        const targetFeature = this.props.associationTargetTypes.filter(type => {
            return type.typeId === parsedValue;
        })[0];
        this.props.onSelectTargetFeatureType(targetFeature);
    }

    handleFetchFeaturesFromNvdb() {
        this.props.onFetchNvbdObjects(this.props.nvdbSearchDistance);
    }

    handleDistanceChange(event: React.ChangeEvent<HTMLInputElement>) {
        let distance = parseInt(event.target.value);
        this.props.setNvdbSearchDistance(distance);
    }

    componentWillMount() {

        // Set distance on mount to prevent race conditions
        this.setState({distance: this.props.nvdbSearchDistance});
    }

    render() {

        const {selectedAssociation} = this.props;

        const anyTargetTypeSelected = !!this.props.selectedAssociationTargetType;
        const featureIsExporting = !!this.props.selectedSourceFeature && !!this.props.selectedSourceFeature.isExporting;
        const selectValue = anyTargetTypeSelected ? this.props.selectedAssociationTargetType.typeId : "";
        const anyTargetsSelected = anyTargetTypeSelected && this.props.selectedTargetFeatures.length > 0;
        const anyTargetHasNvdbMother = this.props.selectedTargetFeatures.some(feature => {
            return feature.associations && feature.associations.foreldre && feature.associations.foreldre.length > 0;
        });
        const title = "Koble sammen valgte objekter";

        let helpText = "";
        if (featureIsExporting) {
            helpText = "Morobjekt er under eksport til NVDB";
        } else if (anyTargetHasNvdbMother) {
            helpText = "NB! Eksisterende kobling vil bli overskrevet";
        }


        if (selectedAssociation && selectedAssociation.origin === "NVDB") {
            return (
                <div className="associations-creator-content">
                    <h2>Koble til datter i NVDB</h2>
                    <div className="infobox">
                        <p>Datafangst støtter ikke sammenkobling mellom 2 objekter fra NVDB i denne versjonen</p>
                    </div>
                </div>
            )
        }
        if (!selectedAssociation) {
            return (
                <div className="associations-creator-content">
                    <h2>Koble til datter i NVDB</h2>
                    <div className="infobox">
                        <p>Velg en morkandidat i venstremenyen</p>
                    </div>
                </div>
            )
        }

        return (
            <div className="associations-creator-content">
                <h2>Koble til datter i NVDB</h2>

                <select onChange={(e) => this.handleSelect(e.target.value)} value={selectValue}>
                    {
                        this.props.associationTargetTypes
                            .map(featureType => {
                                return (
                                    <option value={featureType.typeId}
                                            key={featureType.typeId}>{featureType.name}</option>
                                )
                            }, this)
                    }
                </select>

                <div className="nvdb-controls">
                    <label>
                        Maks avstand til mor
                        <input type="number" id="distanceControl" onChange={(e) => this.handleDistanceChange(e)}
                               defaultValue={this.props.nvdbSearchDistance.toString()}/>
                        m
                    </label>
                    <button onClick={() => this.handleFetchFeaturesFromNvdb()} className="btn btn-default">Hent fra
                        NVDB
                    </button>
                </div>

                <div className="associationButtons">
                    <Button type="button" title={title} className="associate-button"
                            disabled={!anyTargetsSelected || featureIsExporting}
                            onClick={() => this.props.onAssociateTargets("PROJECT_TO_NVDB")}>Koble sammen</Button>
                    <span className="association-create-error-message">
                        {helpText}
                    </span>
                </div>

                <FeatureList featureType={this.props.selectedAssociationTargetType}
                             enforceNoNvdbMothers={true}
                             associationsFlat={this.props.associationsFlat}
                             selectedAssociation={this.props.selectedAssociation}
                             features={this.props.targetFeatures}
                             selectedFeatures={this.props.selectedTargetFeatures}
                             onFeatureClick={this.props.onSelectTargetFeature}
                             disableDescriptiveName={true}
                             tabType={"PROJECT_TO_NVDB"}/>
            </div>
        );

    }

}
